<template>
  <el-dialog
    class="map-setting-dialog"
    :title="$t('settings')"
    :visible="true"
    :width="isEnglish ? '55%' : '50%'"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" :label-width="!isEnglish ? '140px' : '220px'" :rules="rules">
      <!-- <el-form-item label="数据最大值">
        <el-input v-model="form.max"></el-input>
      </el-form-item> -->
      <el-form-item :label="'区域边界宽度' | translateTo(i18nPath)" prop="borderLength">
        <el-input v-model="form.borderLength">
          <span slot="suffix">{{ '倍点间距' | translateTo(i18nPath) }}</span>
        </el-input>
      </el-form-item>
      <el-form-item :label="'设备边界宽度' | translateTo(i18nPath)" prop="deviceBorderLength">
        <el-input v-model="form.deviceBorderLength">
          <span slot="suffix">{{ '倍点间距' | translateTo(i18nPath) }}</span>
        </el-input>
      </el-form-item>
      <el-form-item :label="'点间距' | translateTo(i18nPath)" prop="wInterval">
        <el-input v-model="form.wInterval">
          <span slot="suffix">{{ '经度' | translateTo(i18nPath) }}</span>
        </el-input>
      </el-form-item>
      <el-form-item :label="'点大小' | translateTo(i18nPath)" prop="size">
        <el-input v-model="form.size">
          <span slot="suffix">{{ '米' | translateTo(i18nPath) }}</span>
        </el-input>
      </el-form-item>
      <el-form-item
        :label="'渐变区间' | translateTo(i18nPath)"
        prop="gradients"
        class="gradient-item-wrap"
      >
        <template v-for="(item, index) in form.gradients">
          <div :key="index" class="gradient-item">
            <GradientInput :data="item" @close="handlerRemove(form.gradients, item)" />
            <span class="line" v-if="index !== form.gradients.length - 1">-</span>
          </div>
        </template>
        <el-button class="add-button" @click="appendColor(form.gradients)">+</el-button>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()">{{ $t('cancel') }}</el-button>
      <el-button type="primary" :loading="loading" @click="confirm">
        {{ $t('confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { isArray, isFunction, isNullOrUnDef, isNumber, isString } from '@/utils/is';
import GradientInput from './gradientInput.vue';

export default {
  components: {
    GradientInput
  },
  props: {
    config: {
      type: [Object, null],
      defualt: () => ({})
    }
  },
  data() {
    const makeValidator = msg => {
      return (_, v, callback) => {
        if (isNumber(v) || (isString(v) && !isNaN(v))) {
          callback();
        } else {
          callback(new Error(`${msg}必须为数值`));
        }
      };
    };
    return {
      i18nPath: 'monitor.task',
      form: {},
      loading: false,
      rules: {
        borderLength: [
          { required: true, message: '请输入区域边界宽度' },
          { validator: makeValidator('边界宽度') }
        ],
        deviceBorderLength: [
          { required: true, message: '请输入设备边界宽度' },
          { validator: makeValidator('设备边界宽度') }
        ],
        wInterval: [
          { required: true, message: '请输入点间距' },
          { validator: makeValidator('点间距') }
        ],
        size: [{ required: true, message: '请输入点大小' }, { validator: makeValidator('点大小') }],
        gradients: [
          {
            required: true,
            trigger: 'blur',
            validator: (_, value, callback) => {
              if (!isArray(value) || !value.length) {
                callback(new Error('请添加渐变区间'));
              } else {
                let rangeError = null;
                let count = {};
                let repeatError = null;
                value.forEach(e => {
                  if (rangeError || repeatError) return;
                  count[e.value] = count[e.value] || 0;
                  count[e.value]++;
                  if (e.value > 1 || e.value < 0 || isNaN(e.value)) {
                    rangeError = true;
                  }
                  if (count[e.value] > 1) {
                    repeatError = `${e.value}`;
                  }
                });
                if (rangeError) {
                  callback(new Error('请正确输入渐变区间，渐变区间为0~1。'));
                } else if (repeatError) {
                  callback(new Error(`请勿重复输入,重复值'${repeatError}'`));
                }
                callback();
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    hideLoading() {
      this.loading = false;
    },
    async confirm() {
      this.loading = true;
      const valid = await this.$refs.form.validate();
      if (!valid) return;
      this.$emit('confirm', this.form);
    },
    handleClose(done) {
      this.$emit('close', false);
      isFunction(done) && done();
    },
    handlerRemove(gradients, data) {
      const index = gradients.findIndex(e => e === data);
      gradients.splice(index, 1);
    },
    appendColor(gradients) {
      gradients.push({ value: 1, color: '#000' });
    },
    cloneConfig(config) {
      if (isNullOrUnDef(config)) return;
      this.$set(this, 'form', JSON.parse(JSON.stringify(config)));
      const { gradient } = this.form;
      if (isString(gradient)) {
        this.form.gradient = JSON.parse(gradient);
      } else {
        this.form.gradient = gradient;
      }
      this.$set(
        this.form,
        'gradients',
        Object.keys(gradient).map(e => ({ value: e, color: gradient[e] }))
      );
    }
  },
  watch: {
    config: {
      handler: 'cloneConfig',
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss">
.en {
  .map-setting-dialog {
    .el-input {
      width: 240px;
    }
  }
}

.map-setting-dialog {
  .el-input {
    width: 180px;
  }
  .gradient-item-wrap {
    .el-input {
      width: 100%;
    }
    .el-form-item__content {
      display: flex;
      .gradient-item {
        display: flex;
        align-items: center;
      }
      .add-button {
        margin-left: 15px;
      }
    }
  }
}
</style>
